import React from "react";

/**
 * 6-dot progress indicator. Filled dots = answered. The current step
 * has a slightly larger dot to anchor focus.
 */
export default function ProgressDots({ total = 6, current = 1 }) {
  return (
    <div className="flex items-center gap-1.5" data-testid="netprice-progress" aria-label={`Question ${current} of ${total}`}>
      {Array.from({ length: total }, (_, i) => {
        const idx = i + 1;
        const filled = idx < current;
        const isCurrent = idx === current;
        return (
          <span
            key={i}
            className="rounded-full transition-all"
            data-testid={`netprice-dot-${idx}`}
            style={{
              width: isCurrent ? 18 : 7,
              height: 7,
              background: filled || isCurrent ? "#1d4ed8" : "#e5e7eb",
            }} />
        );
      })}
    </div>
  );
}
